import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const loraComponent: ComponentDef = {
  id: 'lora',
  name: 'LoRA',
  description: 'Low-Rank Adaptation freezes base weights and trains small A/B adapter matrices.',
  category: 'training',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 },
    { name: 'rank', label: 'LoRA rank', type: 'number', default: 16, min: 1, max: 256, step: 1 },
    {
      name: 'variant',
      label: 'Algorithm variant',
      type: 'select',
      default: 'lora',
      options: [
        { label: 'LoRA', value: 'lora' },
        { label: 'QLoRA (4-bit NF4 base)', value: 'qlora' }
      ]
    }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const seq_len = Number(params.seq_len);
    const rank = Number(params.rank);
    const variant = String(params.variant || 'lora');

    const g = new GraphBuilder();
    g.input('x', [seq_len, d_model]);

    if (variant === 'qlora') {
      // Base weight path: quantize to 4-bit NF4, dequantize before matmul
      g.quantize('base_q4', 'x', [d_model, d_model], 4);
      g.dequantize('base_fp16', 'base_q4', [d_model, d_model]);
      g.linear('base', 'base_fp16', [d_model, d_model]);
    } else {
      g.linear('base', 'x', [d_model, d_model]);
    }

    g.linear('a', 'x', [d_model, rank]);
    g.linear('b', 'a', [rank, d_model]);
    g.scale('scaled', 'b', 'alpha/r');
    g.add('adapted', 'base', 'scaled');
    g.output('out', 'adapted');
    return g.build();
  }
};
